import PageHandler from "./PageHandler";
import Pages from "Pages";

class ApplicationsListPageHandler extends PageHandler {
  constructor() {
    super("applications-list", Pages.ApplicationsListPage);
  }

  fetch() {
    this.rootStore.data.ApplicationsStore.fetch();
  }
}

export default ApplicationsListPageHandler;



// WEBPACK FOOTER //
// ./src/Stores/UIStore/PageHandlers/ApplicationsListPageHandler.js